import { render, staticRenderFns } from "./DonationModal.vue?vue&type=template&id=8aa170a0&scoped=true"
import script from "./DonationModal.vue?vue&type=script&lang=js"
export * from "./DonationModal.vue?vue&type=script&lang=js"
import style0 from "./DonationModal.vue?vue&type=style&index=0&id=8aa170a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa170a0",
  null
  
)

export default component.exports